<template>
	<div :class="{ hidden: hidden }" class="pagination-container">
		<el-pagination
			:background="background"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="pageSizes"
			:layout="layout"
			:total="total"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
		/>
	</div>
</template>

<script setup>
//   import { scrollTo } from '@/utils/scroll-to'
import { computed } from 'vue'
const props = defineProps({
	total: {
		required: true,
		type: Number
	},
	page: {
		type: Number,
		default: 1
	},
	limit: {
		type: Number,
		default: 10
	},
	pageSizes: {
		type: Array,
		default() {
			return [10, 15, 20]
		}
	},
	layout: {
		type: String,
		// default: 'total, sizes, prev, pager, next, jumper'
		default: 'total, sizes, prev, pager, next, jumper'
	},
	background: {
		type: Boolean,
		default: true
	},
	hidden: {
		type: Boolean,
		default: false
	}
})
const emit = defineEmits()
const currentPage = computed({
	get() {
		return props.page
	},
	set(val) {
		emit('update:page', val)
	}
})
const pageSize = computed({
	get() {
		return props.limit
	},
	set(val) {
		emit('update:limit', val)
	}
})
function handleSizeChange(val) {
	if (currentPage.value * val > props.total) {
		currentPage.value = 1
	}
	emit('pagination', { page: currentPage.value, limit: val })
}
function handleCurrentChange(val) {
	emit('pagination', { page: val, limit: pageSize.value })
}
</script>

<style scoped>
.pagination-container {
	background: #fff;
	padding: 5px 16px;
}
.pagination-container.hidden {
	display: none;
}
</style>
